import React, { useState } from "react";
import * as notify from "../../../shared/notify";
import { ButtonSelect } from "../../form-inputs/inputs";

const AvailableShots = (props) => {
    const [selectedShot, setSelectedShot] = useState("");
    const availableShotTypes = props.imageViews.filter((imgView) => !props.usedShots.includes(imgView.value));

    const addPlaceholder = () => {
        if (!selectedShot) {
            notify.error("Please select a shot from the list");

            return;
        }

        setSelectedShot("");
        //const returnObj = availableShotTypes.find((s) => { return s.value === val; });
        props.addPlaceholder(selectedShot);
    };
    const updateField = (name, value) => {
        setSelectedShot(value);
    };

    return <ButtonSelect options={availableShotTypes} value={selectedShot} label={props.label} updateOnChange={updateField} buttonClick={addPlaceholder} disabled={props.disabled} />;
};

export default AvailableShots;
